import { TextField } from '@mui/material';
import DisabledFieldTooltip from './DisabledFieldTooltip';

const InputUI = (props) => {
  const tooltipTitle = props.disabled && props.value !== null && props.value !== undefined ? String(props.value) : '';

  return (
    <DisabledFieldTooltip disabled={props.disabled} title={tooltipTitle}>
      <TextField
        sx={{ width: '100%' }}
        autoComplete="off"
        onWheel={(e) => {
          e.target.blur();
        }}
        InputLabelProps={{
          style: { color: '#607d8b' },
        }}
        inputProps={{ step: props.precision, readOnly: props.readOnly ?? false, ...props.inputProps }}
        {...props}
      />
    </DisabledFieldTooltip>
  );
};

export default InputUI;
